import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { QuizProvider } from './context/QuizContext';
import { Landing } from './pages/Landing';
import { Quiz } from './pages/Quiz';
import { LeadForm } from './pages/LeadForm';
import { Result } from './pages/Result';
import { EmailsView } from './pages/EmailsView';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './common/SafeIcon';

function App() {
  return (
    <QuizProvider>
      <BrowserRouter>
        <div className="min-h-screen flex flex-col font-sans text-gray-900">
          
          {/* Header with Logo and Contact */}
          <header className="bg-white border-b border-gray-200 py-2 px-4 sm:px-6 flex justify-between items-center sticky top-0 z-50">
            <Link to="/" className="flex items-center">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/525d05658fdf988acaa34e738d3f286826191483600217441074af5254e1324b9947d16ec384fcc03e2360d22f6a7d9b/images/aW1hZ2UvcG5n/312034cd79c028aad1e85c1e994b94aa.png" 
                alt="Pinoy General Insurance Services" 
                className="h-20 md:h-24 w-auto object-contain scale-110 origin-left"
              />
            </Link>
            
            <a 
              href="tel:+15624021737" 
              className="flex items-center gap-2 text-sm md:text-base font-bold text-brand-navy hover:text-brand-green transition-colors bg-blue-50 hover:bg-green-50 px-4 py-2 rounded-full border border-blue-100 hover:border-green-200"
            >
              <SafeIcon icon={FiIcons.FiPhone} className="w-4 h-4 md:w-5 md:h-5" />
              <span className="hidden sm:inline">(562) 402 - 1737</span>
              <span className="sm:hidden">Call Now</span>
            </a>
          </header>

          {/* Main Content */}
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/quiz" element={<Quiz />} />
              <Route path="/capture" element={<LeadForm />} />
              <Route path="/result" element={<Result />} />
              <Route path="/emails" element={<EmailsView />} />
            </Routes>
          </main>
          
        </div>
      </BrowserRouter>
    </QuizProvider>
  );
}

export default App;